import { RootState } from 'store'

export const withdrawalRequestsSelectors = {
  selectPendingCount: (state: RootState) => state.withdrawalRequests.pendingCount
}
